import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import AppContext from '../../context/AppContext';
import Menu from './Menu';

import './Header.css';

const Logo = 'https://i.postimg.cc/W47Xcyg3/UNI-DUNI-TE-MARCA-DAGUA-Prancheta-1.png';

function Header() {

  const { isLogged, setIsLogged, setUserData } = useContext(AppContext);
  const [openMenu, setOpenMenu] = useState(false);

  const getUserData = async () => {
    const data = JSON.parse(sessionStorage.getItem('login'));
    if (data) {
      setUserData(data.user);
      setIsLogged(true)
    }
  };

  useEffect(() => {
    getUserData();
  }, [isLogged]);

const handleClick = (e) => {
  const { name, value } = e.target;
    switch (name) {
      case 'menu-btn':
        setOpenMenu(!openMenu);
        break;
    
      default:
        break;
    }
  }
  return (
    <header>
      <div className='header-container'>
        {
          isLogged ? (
          <div
            className='menu-btn'
          >
            {
              !openMenu ? (
                <img
                  name="menu-btn"
                  src="https://i.postimg.cc/Z5snLdpW/sandwichmenu-icon.png"
                  alt="menu-icon"
                  onClick={ (e) => handleClick(e) }
                />
              ) : (
                <img
                  name="menu-btn"
                  src="https://i.postimg.cc/CMHzJqnC/Vectorclose-Menu.png"
                  alt="menu-close-icon"
                  onClick={ (e) => handleClick(e) }
                />
              )
            }
          </div>
          ) : (
            <Link to={'/login'} 
                className='menu-btn'>
              <img
                src="https://i.postimg.cc/mgTtz58y/login-icon.png"
                alt="Login-icon"
              />
            </Link>
          )
        }
        <div className="logo-container">
          <Link to={`/`}>
            {/* <img className="logo-header" src={Logo} alt="logo.png" /> */}
          </Link>
        </div>
      </div>
      <div className='lock-bg-space'></div>
      {
        openMenu && isLogged ? <Menu setOpenMenu={setOpenMenu} /> : null
      }
    </header>
  )
}

export default Header